import { DashboardTableFilterTrigger } from '@shigo-ui/dashboard-ui';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { resolveSupplyAppStatusLabel, SupplyInventoryAppStatus } from '../../model';

export function AppsStatusFilter({
  statuses,
  counts,
  onStatusesChange,
}: {
  statuses: SupplyInventoryAppStatus[];
  counts?: Partial<Record<SupplyInventoryAppStatus, number>> | undefined;
  onStatusesChange: (statuses: SupplyInventoryAppStatus[]) => void;
}) {
  const selectedStatuses = new Set(statuses);
  const label = statuses.length
    ? statuses.map(resolveSupplyAppStatusLabel).join(', ')
    : dashboardT('supplyApps.allStatuses');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <DashboardTableFilterTrigger
          label={label}
          aria-label={dashboardT('supplyApps.statusFilter')}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {Object.values(SupplyInventoryAppStatus).map((status) => (
          <DropdownMenuCheckboxItem
            key={status}
            checked={selectedStatuses.has(status)}
            onSelect={(event) => {
              event.preventDefault();
            }}
            onCheckedChange={(checked) => {
              onStatusesChange(
                checked
                  ? Array.from(new Set([...statuses, status]))
                  : statuses.filter((item) => item !== status),
              );
            }}
          >
            <span className="flex min-w-0 flex-1 justify-between gap-3">
              <span>{resolveSupplyAppStatusLabel(status)}</span>
              {counts ? <span className="text-muted-foreground">{counts[status] ?? 0}</span> : null}
            </span>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
